import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

import * as ActionTypes from "../../actions/actionTypes";
import * as ExperienceActions from "../../actions/experiencesActions";
import * as ControlPanelActions from "../../actions/controlPanelActions";
import * as constants from "../../constants";

const loadExperiences = createLogic({
	type: ActionTypes.LOAD_EXPERIENCE_NAVIGATION,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.get(`/experiences/${action.expId}/navigation`)
					.then(data => {
						dispatch(ExperienceActions.loadExperienceNavigationSuccess(data.data));
						if (action.callback) {
							//This tells the component that the experience nav has actually been loaded into state and can be used to initialize the form
							setTimeout(() => {
								action.callback();
							}, 200);
						}
						done();
					})
					.catch(error => {
						dispatch(ControlPanelActions.displayError(error.message));
						done();
					});
			});
	},
});

export default [loadExperiences];
